import { useUserRoleContext } from '@/context/UserRoleContext';

export const useUserRole = () => useUserRoleContext();